import axios from "axios";
const baseURL = "https://api.hometutorx.com/api/v1";
const token = localStorage.getItem("token");
const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
    Token: token,
  },
});

export default axiosInstance;
